import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    DeliveryExpressOrderPayloadT,
    DeliveryGetCitiesResponseT,
    DeliveryGetOrderResponseT,
    DeliveryGetOrdersFilters,
    DeliveryGetOrdersResponseT,
    DeliveryGetTariffsResponseT,
    DeliveryGetTasksResponseT,
    DeliveryPointT,
    DeliveryUpdateStatusResponseT,
} from '../types/delivery.types'

export class DeliveryRepository {
    getCities(
        page: number,
        search?: string,
        limit?: number
    ): Promise<AxiosResponse<DeliveryGetCitiesResponseT>> {
        const params = {
            page,
            search,
            limit,
        }

        return http.get('/delivery/api/city', { params })
    }

    getTariffs(coordinates: DeliveryPointT[]): Promise<AxiosResponse<DeliveryGetTariffsResponseT>> {
        return http.post('/delivery/api/tariff', { coordinates })
    }

    createExpressOrder(payload: DeliveryExpressOrderPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/delivery/api/order', payload)
    }

    getExpressOrders(
        filters: DeliveryGetOrdersFilters
    ): Promise<AxiosResponse<DeliveryGetOrdersResponseT>> {
        return http.get('/delivery/api/admin/order', { params: filters })
    }

    getExpressOrder(order_id: number): Promise<AxiosResponse<DeliveryGetOrderResponseT>> {
        return http.get(`/delivery/api/admin/order/${order_id}`)
    }

    getTasks(page: number): Promise<AxiosResponse<DeliveryGetTasksResponseT>> {
        const params = {
            page,
            limit: 999,
        }

        return http.get(`/delivery/api/task`, { params })
    }

    refreshStatus(order_id: number): Promise<AxiosResponse<DeliveryUpdateStatusResponseT>> {
        return http.put(`/delivery/api/order/status/${order_id}`, null)
    }

    cancelOrder(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/delivery/api/order/${id}/cancel`, { id })
    }

    cancelOrderByReceiver(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/delivery/api/order/receivers/cancel/${id}`, { id })
    }

    addToAccrual(order_id: number): Promise<AxiosResponse<void>> {
        return http.put(`/delivery/api/order/${order_id}/accural`, {})
    }

    massApprove(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/dispatcher/api/deliveries/mass-approve', form_data)
    }
}
